import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {
  public constructor(private http: HttpClient) {}

  public getAddressByPostalCode(postalCode: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/geocoding/${postalCode}`);
  }
}
